export default "__VITE_ASSET__6609ae4b__"